module.exports = __webpack_public_path__ + "static/media/icon-filled-supports.a0e11230.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon-filled-supports.svg
// module id = 1902
// module chunks = 0